var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showProgress)?_c('div',{staticClass:"loading-progress-bar"},[_c('div',{staticClass:"progress-bar__line",style:([{transform:`scale(${_vm._rate}, 1)`},{'background-color':_vm.color}])})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }